import { createKeyCreator } from "@/utils/storage";

export const createModelToolStorageKey = createKeyCreator("model-tool");
